import { render, staticRenderFns } from "./TemplateCode.vue?vue&type=template&id=474c6dbb&"
import script from "./TemplateCode.vue?vue&type=script&lang=js&"
export * from "./TemplateCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports